import type { ListEligibleMembershipsResponse } from '@wix/ambassador-ecom-memberships-spi-host-v1-membership/types';
import { ControllerFlowAPI, Experiments } from '@wix/yoshi-flow-editor';
import settingsParams from '../../../../components/BookingsForm/settingsParams';
import {
  PaymentMethod,
  ReservedPaymentOptionIds,
} from '../../../../types/types';
import { ServicePayment } from '../../../mappers/serviceMapper/utils/payment.mapper';
import {
  DepositOrFullAmountOptionIds,
  isDepositOrFullAmountFeatureEnabled,
  isOfferedAsOneTimeOnly,
  isOfferedAsPricingPlanOnly,
  isServiceHavePricingPlans,
} from '../utils';

export const getDefaultPaymentOptionId = ({
  settings,
  servicePayment,
  memberships,
  isPricingPlanInstalled,
  isDynamicPricingCustomOptions,
  hasEligiblePlans,
  experiments,
  paymentTypes,
}: {
  settings: ControllerFlowAPI['settings'];
  servicePayment: ServicePayment;
  isPricingPlanInstalled: boolean;
  memberships?: ListEligibleMembershipsResponse;
  isDynamicPricingCustomOptions?: boolean;
  hasEligiblePlans?: boolean;
  experiments?: Experiments;
  paymentTypes?: PaymentMethod[];
}) => {
  if (isDynamicPricingCustomOptions) {
    return ReservedPaymentOptionIds.SingleSession;
  }
  const planId = memberships?.eligibleMemberships?.[0]?.id; // todo: change to Selected Plan when implemented

  if (planId) {
    return planId;
  }
  if (isOfferedAsOneTimeOnly(servicePayment) || !isPricingPlanInstalled) {
    const isDepositeOrFullAmountEnabled = isDepositOrFullAmountFeatureEnabled({
      experiments,
      fullUpfrontPaymentAllowed:
        servicePayment.paymentDetails.fullUpfrontPaymentAllowed,
      deposit: servicePayment.paymentDetails.minCharge,
      paymentTypes: paymentTypes ?? [],
    });

    return isDepositeOrFullAmountEnabled
      ? DepositOrFullAmountOptionIds.Deposit
      : ReservedPaymentOptionIds.SingleSession;
  }
  if (isOfferedAsPricingPlanOnly(servicePayment)) {
    return ReservedPaymentOptionIds.BuyAPricingPlan;
  }

  const selected =
    [
      PaymentMethod.SINGLE,
      PaymentMethod.ONLINE,
      PaymentMethod.OFFLINE,
    ].includes(settings.get(settingsParams.defaultPaymentMethod)) ||
    !isServiceHavePricingPlans(servicePayment) ||
    !hasEligiblePlans
      ? ReservedPaymentOptionIds.SingleSession
      : ReservedPaymentOptionIds.BuyAPricingPlan;
  return selected;
};
